// src/api/standardApi.ts
import Storage from 'utils/Storage';
import buildBaseApi from './baseApi';

const getToken = () => Storage.get( 'grupoimpar:token' );

const standardApi = buildBaseApi( {
  baseURL: process.env.REACT_APP_API_URL!,
  getToken,
  handle401: true,
} );

export default standardApi;
